import { ref } from 'vue';

export function useAverageCompletionTimes() {
  const dates = ref([]);  // X-axis: days
  const averageDurationsSeries = ref([]); // Y-axis data

  function calculateAverageCompletionTimes(jobs) {
    const groupedByDay = {};

    jobs.forEach(job => {
      const start = new Date(job.startTime);
      const end = new Date(job.endTime);
      const durationMinutes = (end - start) / (1000 * 60);

      const day = start.toISOString().split('T')[0];

      if (!groupedByDay[day]) {
        groupedByDay[day] = { totalDuration: 0, count: 0 };
      }
      groupedByDay[day].totalDuration += durationMinutes;
      groupedByDay[day].count += 1;
    });

    const sortedDays = Object.keys(groupedByDay).sort();
    const averageDurations = sortedDays.map(day => {
      const stats = groupedByDay[day];
      return +(stats.totalDuration / stats.count).toFixed(2);
    });

    dates.value = sortedDays;
    averageDurationsSeries.value = [
      { name: 'Average (mins)', data: averageDurations }
    ];
  }

  return {
    dates,
    averageDurationsSeries,
    calculateAverageCompletionTimes,
  };
}